import React, {
    createContext,
    useContext,
    useState,
    useCallback,
    useMemo,
} from "react";
import { ThemeMode, createColorUtils } from "./colors";
import { updateThemeColors } from "./index";
import { MantineProvider } from "@mantine/core";

interface ThemeContextType {
    mode: ThemeMode;
    colors: ReturnType<typeof createColorUtils>;
    toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextType | null>(null);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const [mode, setMode] = useState<ThemeMode>("light");

    const toggleTheme = useCallback(() => {
        setMode(prev => (prev === "light" ? "dark" : "light"));
    }, []);

    const colors = createColorUtils(mode);

    // 테마 모드가 변경될 때마다 Mantine 테마도 업데이트
    const currentTheme = useMemo(() => updateThemeColors(mode), [mode]);

    return (
        // <MantineProvider theme={currentTheme}>
        <ThemeContext.Provider value={{ mode, colors, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
        // </MantineProvider>
    );
};

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error("useTheme must be used within a ThemeProvider");
    }
    return context;
};
